// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__2yBql","title":"Contact_title__JSFCl","left":"Contact_left__aHQnN","right":"Contact_right__2_ep_"};